import React from 'react';
import PropTypes from 'prop-types';
import {
  Checkbox,
} from '@shopify/polaris';

function FormCheckbox(props) {
  const {
    disabled,
    id,
    label,
    name,
    onChange,
    value,
  } = props;

  const getValue = () => {
    switch (typeof value) {
      case 'boolean':
        return value;
      case 'number':
        return !!value;
      case 'string':
        return value === '1' || value === 'true';
      default:
        return false;
    }
  };

  const handleChange = (checked) => {
    let newValue;

    switch (typeof value) {
      case 'boolean':
        newValue = checked;
        break;
      case 'number':
        newValue = checked ? 1 : 0;
        break;
      case 'string':
        newValue = checked ? '1' : '0';
        break;
      default:
        newValue = false;
    }
    onChange(newValue);
  };

  return (
    <Checkbox
      disabled={disabled}
      id={id}
      label={label}
      name={name}
      checked={getValue()}
      onChange={(checked) => handleChange(checked)}
    />
  );
}

FormCheckbox.propTypes = {
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default FormCheckbox;
